import React from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import LoginRightInternal from "./LoginRightInternal";

function LoginInternal() {
  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <div className="lg:w-1/2 bg-[rgb(32,137,197)] text-white lg:p-10 flex flex-col justify-center hidden lg:block">
        <div className="flex space-x-6 mb-2 mt-6 opacity-75">
          <Logo src={Images.Login_Logo} alt="logo" />
          {/* <div className="w-20 h-20 mb-10 bg-white rounded-2xl p-1 shadow-lg">
            <img
              src={Images.Login_Logo}
              alt="logo"
              className="w-full h-full object-cover rounded-lg"
            />
          </div> */}
        </div>
        <div>
          <h1 className="lg:text-5xl font-bold mb-4">
            Internal Login to
          </h1>
          <h1 className="lg:text-5xl font-bold mb-8">
            Manage Partner Properties
          </h1>

          <p className="text-sm text-purple-100 mr-9 mb-12 leading-relaxed">
            Property management software that helps you to list properties,
            manage tenants, collect payments, and manage staffs with ease, all
            online.
          </p>
          <div className="bg-white/15 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-white/20">
            <h3 className="font-semibold mb-2">I barely had to do anything</h3>
            <p className="text-sm mb-4 text-purple-100">
              Excellent tool for managing tenants and staff. The complaint
              management system is top-notch. It’s a game-changer for property
              managers.
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-purple-400 rounded-full mr-4 flex items-center justify-center text-white font-bold text-lg">
                  V
                </div>
                <p className="font-semibold">Vinay Arora</p>
              </div>
              <div className="text-yellow-400">★★★★★</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="lg:w-1/2 flex flex-col justify-center">
        <LoginRightInternal />
      </div>
    </div>
  );
}

const Logo = tw.img`w-20 h-20 object-contain mb-10`;

export default LoginInternal;
